module.exports = __webpack_public_path__ + "img/HG0001.162a92a.webp";